
function setCache() {
    function setCacheOne() {
        localStorage.setItem('cacheFlag', 'one')
    }
    function setCacheNoOne() {
        localStorage.setItem('cacheFlag', 'noOne')
    }
    return {
        setCacheOne,
        setCacheNoOne
    }
}
export default setCache
